export enum GameFilter {
  Own = 'own',
  Private = 'private',
  Public = 'public',
  Internal = 'internal',
  Analyzed = 'analyzed',
}
